import { getAicopyOrderCurrencyOptions } from "./aicopyCurrencies";
import { AICOPY_ORDER_OPTION_VOUCHER } from "./aicopyOrderOptions";
import { computeAicopyStrategyVoucherRangeBounds } from "./findAicopyVoucherFollowTarget";
import {
  resolveAicopyDefaultPayCurrency,
  sortAicopyOrderCurrencyOptions,
} from "./resolveAicopyDefaultPayCurrency";
import { isVoucherItemSelectableForFollow } from "./voucherFollowRange";

/** 策略是否存在至少一张可跟单的券（面值落在策略 min/max 内） */
export function hasAicopySelectableVouchersForStrategy(vouchers, strategyDetail, availableBalance = "0") {
  const bounds = computeAicopyStrategyVoucherRangeBounds(strategyDetail, availableBalance);
  if (!bounds || !Array.isArray(vouchers) || !vouchers.length) return false;
  return vouchers.some((v) => isVoucherItemSelectableForFollow(v, bounds.minIn, bounds.maxIn));
}

/**
 * 单策略默认下单币种：该策略有可用券 > 法币有余额 > USDT > USDC > 法币0 > USDT
 * preferredVoucherUserCouponId：外链带参时优先尝试该券是否落在策略区间内
 */
export function resolveAicopyStrategyDefaultPayCurrency({
  vouchers = [],
  strategyDetail,
  availableBalance = "0",
  preferredVoucherUserCouponId = null,
  fiatOptions = [],
  fiatBalanceMap = {},
  usdtBalance = "0",
  usdcBalance = "0",
  primaryFiat = null,
} = {}) {
  const bounds = computeAicopyStrategyVoucherRangeBounds(strategyDetail, availableBalance);
  if (bounds && vouchers.length) {
    const preferred =
      preferredVoucherUserCouponId != null && String(preferredVoucherUserCouponId).trim() !== ""
        ? String(preferredVoucherUserCouponId).trim()
        : null;
    if (preferred) {
      const hit = vouchers.find((v) => String(v.id) === preferred);
      if (hit && isVoucherItemSelectableForFollow(hit, bounds.minIn, bounds.maxIn)) {
        return AICOPY_ORDER_OPTION_VOUCHER;
      }
    }
    if (hasAicopySelectableVouchersForStrategy(vouchers, strategyDetail, availableBalance)) {
      return AICOPY_ORDER_OPTION_VOUCHER;
    }
  }

  return resolveAicopyDefaultPayCurrency({
    hasUsableVouchers: false,
    fiatOptions,
    fiatBalanceMap,
    usdtBalance,
    usdcBalance,
    primaryFiat,
  });
}

/** 策略卡片币种下拉排序上下文：用券选项仅在该策略有可选券时优先 */
export function resolveAicopyStrategyPayCurrencySortCtx(baseCtx, vouchers, strategyDetail, availableBalance = "0") {
  return {
    ...baseCtx,
    hasUsableVouchers: hasAicopySelectableVouchersForStrategy(vouchers, strategyDetail, availableBalance),
  };
}

/** 策略卡片币种下拉选项（含用券，按策略可选券状态排序） */
export function getAicopyStrategyOrderCurrencyOptions(fiatOptions, sortCtx) {
  const base = [...getAicopyOrderCurrencyOptions(fiatOptions), AICOPY_ORDER_OPTION_VOUCHER];
  return sortAicopyOrderCurrencyOptions(base, sortCtx);
}
